import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const serverLabel = (servers, id) => {
  const s = servers.find((x) => x.id === id);
  return s ? `${s.domain}:${s.port}` : "—";
};

function drawHeader(doc, title, subtitle) {
  doc.setFillColor(7, 9, 14);
  doc.rect(0, 0, 210, 28, "F");
  doc.setFillColor(16, 185, 129);
  doc.circle(14, 14, 3.5, "F");
  doc.setTextColor(241, 245, 249);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("SCHARPZ LIVE!", 22, 13);
  doc.setFont("courier", "normal");
  doc.setFontSize(8);
  doc.setTextColor(148, 163, 184);
  doc.text("INTERNET INTERCOM & SIP CONSOLE", 22, 19.5);
  doc.setFontSize(8.5);
  doc.text(`Generated: ${new Date().toLocaleString()}`, 196, 13, { align: "right" });
  doc.text("CONFIDENTIAL", 196, 19.5, { align: "right" });
  doc.setTextColor(30, 41, 59);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.text(title, 14, 40);
  if (subtitle) {
    doc.setFont("courier", "normal");
    doc.setFontSize(9);
    doc.setTextColor(100, 116, 139);
    doc.text(subtitle, 14, 46.5);
  }
}

function drawWarning(doc, y) {
  doc.setFillColor(255, 251, 235);
  doc.setDrawColor(217, 119, 6);
  doc.roundedRect(14, y, 182, 24, 2, 2, "FD");
  doc.setTextColor(146, 64, 14);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text("CONFIDENTIAL — DATA PROTECTION NOTICE", 18, y + 7.5);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8.5);
  doc.text("Keep this list in a safe place. Anyone holding these credentials can register and receive calls.", 18, y + 13.5);
  doc.text("Share only with the intended tenant, store securely, and destroy all copies when no longer needed.", 18, y + 18.5);
}

function drawFooter(doc) {
  doc.setFont("courier", "normal");
  doc.setFontSize(7.5);
  doc.setTextColor(148, 163, 184);
  doc.text(
    `(c) ${new Date().getFullYear()} SCHARPZ Limited - All rights reserved - Unauthorized access prohibited & monitored`,
    105, 290, { align: "center" }
  );
}

function exportExtensionsPdf({ title, subtitle, extensions, servers, filename }) {
  const doc = new jsPDF();
  drawHeader(doc, title, subtitle);
  autoTable(doc, {
    startY: 52,
    head: [["Ext", "Label", "Type", "SIP Username", "SIP Server", "SIP Password"]],
    body: extensions.map((e) => [
      e.number,
      e.label,
      e.kind.toUpperCase(),
      e.sip_endpoint || e.number,
      serverLabel(servers, e.server_id),
      e.sip_secret,
    ]),
    styles: { font: "courier", fontSize: 8.5, cellPadding: 2.5 },
    headStyles: { fillColor: [15, 19, 28], textColor: [16, 185, 129], fontStyle: "bold" },
    alternateRowStyles: { fillColor: [248, 250, 252] },
    columnStyles: { 3: { textColor: [5, 122, 85] }, 5: { textColor: [5, 122, 85] } },
    margin: { left: 14, right: 14 },
  });
  const finalY = doc.lastAutoTable?.finalY || 60;
  drawWarning(doc, Math.min(finalY + 8, 252));
  drawFooter(doc);
  doc.save(filename);
}

export function exportSitePdf(site, extensions, servers) {
  exportExtensionsPdf({
    title: `Extensions List with credentials for site: ${site.name}`,
    subtitle: site.address || "",
    extensions,
    servers,
    filename: `extensions-${site.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}.pdf`,
  });
}

export function exportSinglePdf(ext, sites, servers) {
  const site = sites.find((s) => s.id === ext.site_id);
  exportExtensionsPdf({
    title: `Extension credentials — Ext ${ext.number}`,
    subtitle: site ? `Site: ${site.name}` : "Unassigned extension",
    extensions: [ext],
    servers,
    filename: `extension-${ext.number}-credentials.pdf`,
  });
}
